export const SASBOSS_ENTERPRISES_LOADING = 'SASBOSS_ENTERPRISES_LOADING'
export const SASBOSS_ENTERPRISES_LOADED = 'SASBOSS_ENTERPRISES_LOADED'
export const SASBOSS_ENTERPRISES_FAILED = 'SASBOSS_ENTERPRISES_FAILED'

export const SASBOSS_ENTERPRISE_UPDATING = 'SASBOSS_ENTERPRISE_UPDATING'
export const SASBOSS_ENTERPRISE_UPDATED = 'SASBOSS_ENTERPRISE_UPDATED'
export const SASBOSS_ENTERPRISE_UPDATE_FAILED = 'SASBOSS_ENTERPRISE_UPDATE_FAILED'

export const SASBOSS_SYNC_TRIGGERING = 'SASBOSS_SYNC_TRIGGERING'
export const SASBOSS_SYNC_TRIGGERED = 'SASBOSS_SYNC_TRIGGERED'
export const SASBOSS_SYNC_TRIGGER_FAILED = 'SASBOSS_SYNC_TRIGGER_FAILED'
